"use client";

import React from "react";
import { Hexagon } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = ["BIM coordination and architectural wireframing", "Real-time site progress and engineering documentation", "High-precision structural modeling and clash detection", "Automated technical reporting and site analytics"];
export default function LaminateDetails() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="149879" id="project-details" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Text Column */}
          <div ref={textRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-3xl md:text-5xl font-default font-extrabold text-foreground mb-6 tracking-tighter">
              Structural Integrity & Precision
            </h2>
            <p className="text-muted-foreground font-default text-lg leading-[1.6] mb-8">
              Our architectural workflow integrates high-fidelity BIM wireframes with rigorous site progress monitoring. We prioritize technical readability and engineering accuracy, ensuring that every structural layer aligns perfectly with the foundational design specifications and project timelines.
            </p>
            
            <ul className="space-y-4">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <Hexagon className="w-5 h-5 text-ring shrink-0 mt-1" strokeWidth={1.5} aria-hidden="true" />
                  <span className="text-[#0A192F] font-mono text-sm leading-[1.6]">{feature}</span>
                </li>)}
            </ul>
          </div>

          {/* Image/Carousel Column */}
          <div ref={imageRef} className={`lg:col-span-7 mt-10 lg:mt-0 transition-all duration-1000 delay-150 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="relative w-full aspect-[4/3] md:aspect-[16/10] rounded-none overflow-hidden shadow-none">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/modern_living_room_laminate_floor.png" alt="Detailed BIM wireframe and site progress documentation" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}